import type { Dispatch, SetStateAction } from 'react'
import { createContext, useContext } from 'react'

type ProgressState = string | undefined

type UseProgressValues = [
  ProgressState,
  Dispatch<SetStateAction<ProgressState>>,
]

export const ProgressContext = createContext<UseProgressValues | null>(null)

export const useProgress = (): UseProgressValues =>
  useContext(ProgressContext) as UseProgressValues
